import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { site } from "@/data/store";

const links = [
  { id: "shop", label: "Shop" },
  { id: "how-it-works", label: "How it works" },
  { id: "about", label: "About" },
  { id: "faq", label: "FAQ" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    if (pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", `/#${id}`);
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-black/10 bg-[#F7F5F1]/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 sm:px-8 lg:px-12">
        <Link to="/" data-testid="brand-logo" className="font-serif text-2xl tracking-[0.28em]" onClick={() => setOpen(false)}>
          {site.brandName}
        </Link>
        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <a key={l.id} href={`/#${l.id}`} data-testid={`nav-${l.id}`} onClick={(e) => go(e, l.id)} className="nav-link text-[12px] font-medium uppercase tracking-[0.16em]">
              {l.label}
            </a>
          ))}
        </nav>
        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
          className="-mr-2 p-2 md:hidden"
        >
          {open ? <X className="h-5 w-5" strokeWidth={1.5} /> : <Menu className="h-5 w-5" strokeWidth={1.5} />}
        </button>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="fade-in border-t border-black/10 bg-[#F7F5F1] md:hidden">
          {links.map((l) => (
            <a key={l.id} href={`/#${l.id}`} data-testid={`mobile-nav-${l.id}`} onClick={(e) => go(e, l.id)} className="block border-b border-black/10 px-5 py-5 font-serif text-2xl">
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};
